export default __webpack_public_path__ + "assets/images/082ba49a74ef971ab98589172f82ba39.png";